import { hasOfferInCandidacy, type HrWorkflowView } from '@vigeo/shared';

/**
 * Whether the person has an offer that counts in their current candidacy.
 *
 * The one place the web reads that, so the Overview's next action and Offer and stage's empty
 * state cannot disagree. The definition itself is `hasOfferInCandidacy` in `@vigeo/shared`, which
 * is a reading of `offerStandings`: a withdrawn offer, or one left over from an earlier
 * candidacy, is not an offer in progress.
 */
export function workflowHasOffer(view: HrWorkflowView, at: string = new Date().toISOString()): boolean {
  return hasOfferInCandidacy({ records: view.records, steps: view.offerSteps, candidacySince: view.candidacySince }, at);
}
